module.exports = __webpack_public_path__ + "media/src/images/logo_white-0bb00ee30ac527481601de295ff61008.svg";